<section class="contact-page">
  <app-header />

  <main class="contact-page__content">
    <div class="contact-page__group">
      <a
        class="contact-page__email"
        href="mailto:contact.dariem@gmail.com"
      >
        <span class="contact-page__email-arrow">→</span>
        <span>CONTACT.DARIEM&#64;GMAIL.COM</span>
      </a>

      <div
        class="contact-page__hero"
        aria-label="Let's create beautiful experiences?"
      >
      <div class="contact-page__line contact-page__line--top">
        Let&apos;s create
      </div>

      <img
        class="contact-page__beautiful"
        src="/contact-beautiful.svg"
        alt=""
        aria-hidden="true"
      >

        <div class="contact-page__line contact-page__line--bottom">
          experiences?
        </div>
      </div>
    </div>
  </main>
</section>
